import styled from "styled-components";
import { devices } from "../styles/Breakpoints";

export const ButtonsBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  position: absolute;
  bottom: 0;
  right: 0;
  margin-right: 20px;

  @media ${devices.tablet} {
    flex-direction: row-reverse;
    margin-right: 56px;
    height: 64px;
  }
`;

export const MuteButton = styled.button`
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 2px;
  background-color: ${(props: { muted?: boolean }) =>
    props.muted ? "#B3B3B3" : ({ theme }) => theme.colors.nrmaBlue};

  margin-bottom: 12px;

  @media ${devices.tablet} {
    margin-bottom: 4px;
    margin-left: 12px;
  }
`;

export const OpenChatDiv = styled.div`
  display: flex;
  background-color: white;
  box-shadow: 0px 0px 6px rgb(0 0 0 / 25%);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin-right: 12px;
  width: 281px;
  height: 48px;
  form {
    display: flex;
    align-items: center;
    width: 100%;
  }
  @media ${devices.tablet} {
    margin-right: 24px;
    width: 424px;
  }
`;

export const ChatButton = styled.button`
  min-width: 40px;
  height: 40px;
  border: none;
  border-radius: 2px;
  background-color: ${(props: { closed?: boolean }) =>
    props.closed ? "#B3B3B3" : ({ theme }) => theme.colors.nrmaBlue};
  cursor: pointer;

  margin-bottom: ${(props: { closed?: boolean }) =>
    props.closed ? "0px" : "4px"};

  @media ${devices.tablet} {
    margin-bottom: 4px;
  }
`;

export const OpenChatButton = styled.button`
  position: relative;
  min-width: 48px;
  height: 48px;
  border-top-left-radius: 8px;
  border: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.white};

  & > img:first-child {
    width: 12px;
    height: 12px;
  }

  & > img:last-child {
    position: absolute;
    top: 8px;
    left: 8px;
  }
  div {
    display: inline-block;
  }
  @media ${devices.tablet} {
    min-width: 56px;
    height: 56px;

    & > img:last-child {
      position: absolute;
      top: 12px;
      left: 12px;
    }
  }
`;

export const ChatInput = styled.input`
  padding: 3px 0 3px 6px;
  margin-left: 9px;
  border: none;
  height: 20px;
  width: 100%;
  border-left: 2px solid #e8e8e8;
  outline: none;
`;

export const SendChatButton = styled.button`
  border: 0;
  margin-right: 12px;
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  img {
    display: inline-block;
    width: 18px;
    height: 18px;
  }
`;

export const VideoButton = styled.button`
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 2px;
  background-color: ${(props: { off?: boolean }) =>
    props.off ? "#B3B3B3" : ({ theme }) => theme.colors.nrmaBlue};
  margin-bottom: 12px;
  @media ${devices.tablet} {
    margin-bottom: 4px;
    margin-left: 12px;
  }
`;

export const MicandInputDiv = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  height: 48px;
  @media ${devices.tablet} {
    align-items: flex-end;
  }
`;
